import { render } from "./MyFooter.vue?vue&type=template&id=2db28c59&scoped=true"
import script from "./MyFooter.vue?vue&type=script&lang=js"
export * from "./MyFooter.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2db28c59"

export default script